export default {
    pageTitle: '我的會員',
    vip: '我的會員',
    card1: '白金卡',
    card2: '鑽石卡',
    card3: '黑金卡',
    card4: '黑金',
    wan: '萬',
    tip1: '上月日均資產≥',
    tip1after: '萬USD，可享有',
    v1: 'V1權益',
    v2: 'V2權益',
    v3: 'V3權益',
    qrcode1: '保存下方二維碼，微信掃一掃',
    qrcode2: '添加您的專屬客戶經理領取特權',
    add: '已添加',
    lookMoney: '查看資產',
    privilege: '尊享特權',
    gift: '尊享禮遇',
    giftLevel: '禮遇等級',
    giftDes: '「復星財富星級禮遇」是面向高凈值投資者的全球一站式財富管理綜合禮遇服務。',
    giftLevelDes: '禮遇分為3個等級，每個等級由過去一個自然月的日均AUM資產決定，等級越高，享受到的專屬禮遇服務越多。',
    privilege1: '健康保障',
    privilege2: '快樂生活',
    privilege3: '旅遊休閑',
    privilege4: '權益禮盒',
    privilege5: '特權聯動',
    btn1: '存入資金',
    btn2: '前往交易',
    level: '當前等級',
    nodb: '未達標',
    qidai: '更多權益，敬請期待',
    nosatisfy: '您的上月日均資產未達到領取條件',
    lookMore: '查看更多',
    lookLess: '收起更多',
    comingSoonTips: '高客權益功能即將上線，敬請期待。',
    aumyip: '*日均AUM資產達標後次月1號自動升級權益',
    qy: '權益',
    autoTip: '將自動獲得',
    ling: '另',
    tips: '證券價格有時可能會非常波動。證券價格可升可跌，甚至變成毫無價值。買賣證券未必一定能夠賺取利潤，反而可能會招致損失。以上內容純粹僅供參考之用，並非及不應被視為出售建議、推銷或遊說認購任何投資產品。在進行任何交易之前，客戶應根據個人目標及本身狀況作出投資決定，倘若有需要，應尋求獨立專業意見。本內容如有任何更改，恕不另行通知。',
    dialogTip: '將離開星財富APP前往【星財甄享匯】微信小程序，進行權益的查看與使用',
    dialogTip1: '請先前往【我的】- 【關于我們】更新APP版本，更新後可查看財富甄享匯內容詳情',
    dialogBtn: '確認前往',
    dialogBtn1: '立即更新',
}
